// BalanceModal.jsx
import React from "react";
import Modal from "react-modal";
import CombinedGastosView from "./CombinedGastosView";

const fullScreenStyles = {
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 10400,            
  },
  content: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: "24px",
    border: "none",
    borderRadius: 0,
    width: "100vw",
    height: "100vh",
    overflow: "auto",
    fontFamily: "Roboto, sans-serif",
    position: "relative",
    zIndex: 10500,            
  },
};

// ─── Botón “X” fijo a la esquina
function CloseBtn({ onClick }) {
  return (
    <button
      onClick={onClick}
      aria-label="Cerrar"
      style={{
        position: "fixed",      
        top: "20px",
        right: "28px",
        zIndex: 10600,          
        fontSize: "30px",
        lineHeight: 1,
        background: "none",
        border: "none",
        color: "#555",
        cursor: "pointer",
      }}
    >
      ×
    </button>
  );
}

export default function BalanceModal({ isOpen, onClose, orderIds }) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Balance de Pedidos"
      style={fullScreenStyles}
    >
      <CloseBtn onClick={onClose} />

      <h2 style={{ marginTop: 0 }}>Balance</h2>

      <CombinedGastosView orderIds={orderIds} />
    </Modal>
  );
}
